import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  flexGrow: { flexGrow: 1 },
  filtersPaper: { padding: 10, marginTop: 15 },
}));
